import { render, staticRenderFns } from "./AgentPay.vue?vue&type=template&id=0c041165&scoped=true"
import script from "./AgentPay.vue?vue&type=script&lang=js"
export * from "./AgentPay.vue?vue&type=script&lang=js"
import style0 from "./AgentPay.vue?vue&type=style&index=0&id=0c041165&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c041165",
  null
  
)

export default component.exports